import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-300">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="lg:w-[40%]">
            <h2 className="font-heading text-4xl font-bold text-background-50 mb-2">吃瓜爆料</h2>
            <p className="text-lg text-background-400 mb-6">每日大赛，独家爆料</p>
            <p className="text-sm text-background-500 leading-relaxed max-w-md">
              吃瓜爆料网 —— 娱乐圈内幕大瓜实时追踪平台。每日更新最全黑料合集，明星网红塌房、反差视频、不雅黑料，真实爆料深扒秘闻，带你体验吃瓜快感。
            </p>
          </div>

          <div className="lg:w-[60%] grid grid-cols-3 gap-8">
            <div>
              <h3 className="font-semibold text-background-100 text-sm mb-4">热门分类</h3>
              <div className="flex flex-col gap-2.5">
                <Link to="/category/mingxing-tafang" className="text-sm text-background-400 hover:text-background-200 transition-colors">明星塌房</Link>
                <Link to="/category/wanghong-fanche" className="text-sm text-background-400 hover:text-background-200 transition-colors">网红翻车</Link>
                <Link to="/category/zongyi-neimu" className="text-sm text-background-400 hover:text-background-200 transition-colors">综艺内幕</Link>
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-background-100 text-sm mb-4">关于我们</h3>
              <div className="flex flex-col gap-2.5">
                <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors">品牌介绍</Link>
                <Link to="/about#reviews" className="text-sm text-background-400 hover:text-background-200 transition-colors">用户评价</Link>
                <Link to="/about#contact" className="text-sm text-background-400 hover:text-background-200 transition-colors">联系我们</Link>
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-background-100 text-sm mb-4">法律声明</h3>
              <div className="flex flex-col gap-2.5">
                <Link to="/about#privacy" className="text-sm text-background-400 hover:text-background-200 transition-colors">隐私政策</Link>
                <Link to="/about#disclaimer" className="text-sm text-background-400 hover:text-background-200 transition-colors">免责声明</Link>
                <Link to="/about#contact" className="text-sm text-background-400 hover:text-background-200 transition-colors">投诉建议</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2026 吃瓜爆料网. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <Link to="/about#contact" className="text-background-400 hover:text-background-200 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </Link>
            <Link to="/about#contact" className="text-background-400 hover:text-background-200 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </Link>
            <Link to="/about#contact" className="text-background-400 hover:text-background-200 transition-colors" aria-label="抖音">
              <i className="ri-tiktok-line text-lg"></i>
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
